import script from "./CompareBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareBarChart.vue?vue&type=script&setup=true&lang=js"

import "./CompareBarChart.vue?vue&type=style&index=0&id=f6fefa20&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6fefa20"]])

export default __exports__